// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Days **/

.formats-styles_points__Jd0gf {
    display: flex;
    font-size: 16px;
    align-items: center;
    justify-content: center;
}

.formats-styles_points__Jd0gf div {
    background: #1650b4;
    width: 16px;
    height: 16px;
    border-radius: 50%;
}

.formats-styles_points__Jd0gf div:not(:last-child) {
    margin-right: 10px;
}

/** DescCurrency **/

.formats-styles_progressPerc__52uBM {
    width: 100px;
    height: 4px;
    margin: 0 auto 10px;
    position: relative;
}

.formats-styles_progressPerc__52uBM:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--light-grey);
    opacity: 0.5;
}

.formats-styles_progressPerc__52uBM div {
    height: inherit;
    background: #2751ae;
    position: relative;
    z-index: 2;
}

/** Description **/

.formats-styles_expandedTip__vYAFc:first-letter {
    text-transform: capitalize;
}

/** Holders **/

.formats-styles_flex__Ste0J {
    display: flex;
    align-items: center;
    justify-content: center;
}

/** Progressbar **/

.formats-styles_progress__YnbL2 {
    width: 80px;
    height: 5px;
    margin: 0 auto 10px;
    position: relative;
    display: flex;
}

.formats-styles_progress__YnbL2 div {
    width: 20px;
    background: var(--light-grey);
    opacity: 0.5;
}

/*.progress div:first-child {*/
/*    background: #1650b4;*/
/*    opacity: 0.25;*/
/*}*/

.formats-styles_progress__YnbL2[databar='1'] div:nth-child(1),
.formats-styles_progress__YnbL2[databar='2'] div:nth-child(1),
.formats-styles_progress__YnbL2[databar='3'] div:nth-child(1),
.formats-styles_progress__YnbL2[databar='4'] div:nth-child(1) {
    background: #1650b4;
    opacity: 0.25;
}

.formats-styles_progress__YnbL2[databar='2'] div:nth-child(2),
.formats-styles_progress__YnbL2[databar='3'] div:nth-child(2),
.formats-styles_progress__YnbL2[databar='4'] div:nth-child(2) {
    background: #1650b4;
    opacity: 0.5;
}

.formats-styles_progress__YnbL2[databar='3'] div:nth-child(3),
.formats-styles_progress__YnbL2[databar='4'] div:nth-child(3) {
    background: #1650b4;
    opacity: 0.75;
}

.formats-styles_progress__YnbL2[databar='4'] div:nth-child(4) {
    background: #1650b4;
    opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ComparisonTable/formats/formats-styles.module.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mBAAmB;;AAEnB;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA,kBAAkB;;AAElB;IACI,0BAA0B;AAC9B;;AAEA,cAAc;;AAEd;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,kBAAkB;;AAElB;IACI,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA,8BAA8B;AAC9B,2BAA2B;AAC3B,qBAAqB;AACrB,IAAI;;AAEJ;;;;IAII,mBAAmB;IACnB,aAAa;AACjB;;AAEA;;;IAGI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd","sourcesContent":["/** Days **/\n\n.points {\n    display: flex;\n    font-size: 16px;\n    align-items: center;\n    justify-content: center;\n}\n\n.points div {\n    background: #1650b4;\n    width: 16px;\n    height: 16px;\n    border-radius: 50%;\n}\n\n.points div:not(:last-child) {\n    margin-right: 10px;\n}\n\n/** DescCurrency **/\n\n.progressPerc {\n    width: 100px;\n    height: 4px;\n    margin: 0 auto 10px;\n    position: relative;\n}\n\n.progressPerc:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--light-grey);\n    opacity: 0.5;\n}\n\n.progressPerc div {\n    height: inherit;\n    background: #2751ae;\n    position: relative;\n    z-index: 2;\n}\n\n/** Description **/\n\n.expandedTip:first-letter {\n    text-transform: capitalize;\n}\n\n/** Holders **/\n\n.flex {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/** Progressbar **/\n\n.progress {\n    width: 80px;\n    height: 5px;\n    margin: 0 auto 10px;\n    position: relative;\n    display: flex;\n}\n\n.progress div {\n    width: 20px;\n    background: var(--light-grey);\n    opacity: 0.5;\n}\n\n/*.progress div:first-child {*/\n/*    background: #1650b4;*/\n/*    opacity: 0.25;*/\n/*}*/\n\n.progress[databar='1'] div:nth-child(1),\n.progress[databar='2'] div:nth-child(1),\n.progress[databar='3'] div:nth-child(1),\n.progress[databar='4'] div:nth-child(1) {\n    background: #1650b4;\n    opacity: 0.25;\n}\n\n.progress[databar='2'] div:nth-child(2),\n.progress[databar='3'] div:nth-child(2),\n.progress[databar='4'] div:nth-child(2) {\n    background: #1650b4;\n    opacity: 0.5;\n}\n\n.progress[databar='3'] div:nth-child(3),\n.progress[databar='4'] div:nth-child(3) {\n    background: #1650b4;\n    opacity: 0.75;\n}\n\n.progress[databar='4'] div:nth-child(4) {\n    background: #1650b4;\n    opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"points": `formats-styles_points__Jd0gf`,
	"progressPerc": `formats-styles_progressPerc__52uBM`,
	"expandedTip": `formats-styles_expandedTip__vYAFc`,
	"flex": `formats-styles_flex__Ste0J`,
	"progress": `formats-styles_progress__YnbL2`
};
export default ___CSS_LOADER_EXPORT___;
